var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{attrs:{"id":"app"},on:{"click":_vm.globalClick,"submit":function($event){$event.preventDefault();}}},[_c('router-view',{on:{"sendEvent":_vm.receiveEvent}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }